import request from 'axios';
import { DEFAULT_PAGINATION_PAGE_SIZE } from 'common/pager/constants';
import { getProjectIdFromUrl } from 'project/utils';

/* ACTIONS
================================================================================================ */
export const FETCH_CASE_STUDIES = 'crowdspring/marketing/FETCH_CASE_STUDIES';
export const FETCH_CASE_STUDIES_SUCCESS = 'crowdspring/marketing/FETCH_CASE_STUDIES_SUCCESS';

export const FETCH_REVIEWS = 'crowdspring/marketing/FETCH_REVIEWS';
export const FETCH_REVIEWS_REQUEST = 'crowdspring/marketing/FETCH_REVIEWS_REQUEST';
export const FETCH_REVIEWS_SUCCESS = 'crowdspring/marketing/FETCH_REVIEWS_SUCCESS';

export const FETCH_REVIEW_STATS = 'crowdspring/marketing/FETCH_REVIEW_STATS';
export const FETCH_REVIEW_STATS_SUCCESS = 'crowdspring/marketing/FETCH_REVIEW_STATS_SUCCESS';

export const CLEAR_REVIEWS = 'crowdspring/marketing/CLEAR_REVIEWS';

export const FETCH_REFERRALS = 'crowdspring/marketing/FETCH_REFERRALS';
export const FETCH_REFERRALS_SUCCESS = 'crowdspring/marketing/FETCH_REFERRALS_SUCCESS';

const FETCH_BOOKS = 'crowdspring/marketing/FETCH_BOOKS';
const FETCH_BOOKS_SUCCESS = 'crowdspring/marketing/FETCH_BOOKS_SUCCESS';

const FETCH_GUIDES = 'crowdspring/marketing/FETCH_GUIDES';
const FETCH_GUIDES_SUCCESS = 'crowdspring/marketing/FETCH_GUIDES_SUCCESS';

const FETCH_WEBINARS = 'crowdspring/marketing/FETCH_WEBINARS';
const FETCH_WEBINARS_SUCCESS = 'crowdspring/marketing/FETCH_WEBINARS_SUCCESS';

/* HELPERS
================================================================================================ */
export const createReferralsRequest = formData => request.post('/api/v1/referrals/', formData);

export const subscribeRequest = formData => {
  const url = formData.tags? "/api/v1/bb/external_leads/" : "/api/v1/landing-pages/log_visitor/";
  return request.post(url, formData);
}


/* INITIAL STATES
================================================================================================ */
export const initialState = {
  caseStudies: [],
  reviews: [],
  reviewCount: 0,
  nextReviewPage: 1,
  fetchingReviews: false,
  referrals: [],
  reviewStats: {},
  books: [],
  guides: [],
  webinars: []
};

/* REDUCERS
================================================================================================ */
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_REVIEW_STATS_SUCCESS:
      return {
        ...state,
        reviewStats: action.payload
      };
    case FETCH_CASE_STUDIES_SUCCESS:
      return {
        ...state,
        caseStudies: action.payload,
      };
    case FETCH_REVIEWS_REQUEST:
      return {
        ...state,
        fetchingReviews: true
      };
    case FETCH_REVIEWS_SUCCESS:
      return {
        ...state,
        reviews: [...state.reviews, ...action.payload.results],
        reviewCount: action.payload.count,
        nextReviewPage: state.nextReviewPage + 1,
        fetchingReviews: false
      };
    case CLEAR_REVIEWS:
      return {
        ...state,
        reviews: [],
        reviewCount: 0,
        nextReviewPage: 1
      };
    case FETCH_REFERRALS_SUCCESS:
      return {
        ...state,
        referrals: action.payload
      };
    case FETCH_BOOKS_SUCCESS:
      return {
        ...state,
        books: action.payload
      };
    case FETCH_GUIDES_SUCCESS:
      return {
        ...state,
        guides: action.payload
      };
    case FETCH_WEBINARS_SUCCESS:
      return {
        ...state,
        webinars: action.payload
      };
    default:
      return state;
  }
}

export const fetchReviewStatsIfNeeded = (params={}) => (dispatch, getState) => {
  const { marketing } = getState();
  const hasProjectId = !!getProjectIdFromUrl(params);

  /* ignore if fetching from project pages or already fetched */
  if (hasProjectId || Object.keys(marketing.reviewStats).length > 0) {
    return Promise.resolve();
  }

  return dispatch({
    type: FETCH_REVIEW_STATS,
    promise: request.get('/api/v1/csratings/stats/')
  });
};


export const fetchCaseStudiesIfNeeded = () => (dispatch, getState) => {
  const { caseStudies } = getState().marketing;

  if (!!caseStudies && caseStudies.length > 0) {
    return Promise.resolve();
  }

  return dispatch({
    type: FETCH_CASE_STUDIES,
    promise: request.get('/api/v1/case-studies/')
  });
};

export const fetchReviews = (subcatIds, opts={}) => (dispatch, getState) => {
  let { pageSize, sortBy } = opts;
  pageSize = pageSize || DEFAULT_PAGINATION_PAGE_SIZE;
  const { nextReviewPage } = getState().marketing;
  const offset = (nextReviewPage - 1)*pageSize;
  let queryStr = `?limit=${pageSize}&offset=${offset}&published=published`;
  if (subcatIds) {
    queryStr += subcatIds.reduce((acc, subcatId) => `${acc}&subcategories=${subcatId}`, '');
  }
  if (sortBy) {
    queryStr += `&sort=${sortBy}`;
  }
  const promise = request.get(`/api/v1/csratings/${queryStr}`);

  dispatch({
    type: FETCH_REVIEWS,
    promise
  });

  return promise;
};

export const clearReviews = () => {
  return {
    type: CLEAR_REVIEWS
  };
}

export const fetchReferrals = () => (dispatch) => {
  return dispatch({
    type: FETCH_REFERRALS,
    promise: request.get('/api/v1/referrals/')
  });
};

export const fetchBooksIfNeeded = () => (dispatch, getState) => {
  const { books } = getState().marketing;

  if (!!books && books.length > 0) {
    return Promise.resolve();
  }

  return dispatch({
    type: FETCH_BOOKS,
    promise: request.get('/api/v1/books/')
  });
};

export const fetchGuidesIfNeeded = () => (dispatch, getState) => {
  const { guides } = getState().marketing;

  if (!!guides && guides.length > 0) {
    return Promise.resolve();
  }

  return dispatch({
    type: FETCH_GUIDES,
    promise: request.get('/api/v1/marketing-guides/')
  });
};

export const fetchWebinarsIfNeeded = () => (dispatch, getState) => {
  const { webinars } = getState().marketing;

  if (!!webinars && webinars.length > 0) {
    return Promise.resolve();
  }

  return dispatch({
    type: FETCH_WEBINARS,
    promise: request.get('/api/v1/webinars/')
  });
};
